module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AnNO"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 3: God’s Rhythm"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pAZg"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch04",
      "id": "AB_cha04"
    }
  }, [_vm._v("JANUARY 3"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2"
  }, [_vm._v("God’s Rhythm")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAQC"
    }
  }, [_c('em', [_vm._v("“The seventh day is the Sabbath of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God. In it you shall do no work.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pA8Y"
    }
  }, [_vm._v("—Exodus 20:10")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "AM2"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("A")])]), _vm._v("re you someone one who reads the instructions before you start assembling the bike or the bookcase? Paying attention to what manufacturers have to say about what they’ve made is a good thing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAGI"
    }
  }, [_vm._v("In the command to rest from Exodus, the fourth of the Ten Commandments, we see a basic rhythm God wove into His creation: six days of work followed by a day of rest. How could we regret setting apart that one day to rest and let God reorient, redirect, recharge, and refresh us? After all, when we do so, we are living according to the Manufacturer’s specifications.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAQt"
    }
  }, [_vm._v("Sometimes, though, a manufacturer doesn’t address every situation that might arise. Many of us have learned, for instance, that turning off our computers or smartphones for a few minutes and then restarting them can override a glitch, and we’re good to go!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAuJN"
    }
  }, [_vm._v("But you and I are far more complex than any computer or smartphone. Let’s be thankful that God knows how important it is for us to turn off, to slow down, to rest so He can reset us for use again in His kingdom work. God has given us the instructions; all we have to do is follow them!")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAy8"
    }
  }, [_c('em', [_vm._v("Thank You, Lord, for wanting to bless me with rest. Please give me the discipline to choose Your rhythm for my life.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9213caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 78
// module chunks = 0